export default {"src":"/_next/static/image/public/images/ic_plus_filter.a463bcb35d43ab0623d95fd3a2a20166.svg","height":16,"width":16};